/**
 * @param  {array} arr     result from catsInOneCntForBar.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[{
  name: "Category",
  //colorByPoint: true,
  data: [{
    name: "Animals",
    y: 56.33,
    drilldown: "Animals"

  }, {
    name: "Coffee",
    y: 24.03,
    drilldown: "Coffee"
  }, 
  ...
  ]
}]
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catsInOneCntForBarEachYear = catsInOneCntForBarEachYear;
exports.catsInOneCntForBarEachYearJustY = catsInOneCntForBarEachYearJustY;

function catsInOneCntForBarEachYear(arr, index) {

  var output = [];
  output.push({
    name: arr[0].name,
    max: arr[0].max,
    data: []
  });

  arr[0].data.forEach(function (d, i) {
    output[0].data[i] = {
      name: d.name,
      y: d.y[index],
      drilldown: d.name
    };
  });
  //console.dir(output)
  return output;
}

/**
 * cntsInOneCatForPieEachYearJustY 
 * @param  {array} arr     result from catsInOneCntForBar.js
 * @param  {number} index  which year
 * @return {array}         as below
 */
/*
[12, 23, 21,...]
 */

function catsInOneCntForBarEachYearJustY(arr, index) {

  var output = [];
  arr[0].data.forEach(function (d) {
    output.push(d.y[index]);
  });
  return output;
}
//# sourceMappingURL=data:application/json;base64,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